import { useCartContext } from "@/src/context/CartContext";
import { PageHero } from "@/src/components/PageHero";
import { CollectionGrid } from "./(sections)/CollectionGrid";
import { Newsletter } from "@/src/pages/home/(sections)/newsletter/Newsletter";
import { AppData } from "@/src/constants/app-data";

export function CollectionPage() {
    const { addToCart } = useCartContext();

    return (
        <>
            <PageHero
                image="https://images.unsplash.com/photo-1603006905003-be475563bc59?auto=format&fit=crop&q=80&w=2000"
                label={`${AppData["AppName"]}`}
                title="The Collection"
            />
            <CollectionGrid onAddToCart={addToCart} />
            <Newsletter />
        </>
    );
}
